import React, { useState, useEffect } from 'react'
import { AiOutlineLoading } from "react-icons/ai"
import { paymentService } from '../_services/payment.service'
import { Link } from 'react-router-dom'

import { config } from '../config'
const base_url = config.apiBaseUrl

const CallbackFailed = (props) => {

  // const [id, setId] = useState(props.match.params.id)
  // const [loading, setLoading] = useState(true)
  // const [data, setData] = useState({})
  // const [error, setError] = useState({})
  // const [showRegistrationPrintDialog, setShowRegistrationPrintDialog] = useState(false)

  // useEffect(() => {

  //   let id_ = props.match.params.id;

  //   setId(id_)

  //   setLoading(false)

  //   // getData(id_)

  // }, [props.match.params.id])

  // const getData = (id_) => {

  //   paymentService.InqueryPayment(id_)
  //     .then((res) => {

  //       let newData = res.data;
  //       newData["id"] = newData.memberId;

  //       console.log(newData);

  //       setData(newData)

  //       setLoading(false)

  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setError(err)
  //       setLoading(false)
  //     });

  // }

  // const handleTransferToBank = (id) => {

  //   this.setState({ transferToBankLoading: id })

  //   window.location.assign(base_url + 'bank/TransferToBank/' + id)
  // }

  return (
    <React.Fragment>
      <div className="container-fluid login-body">
        <div className="row flex-row">
          <div className="col-md-8 col-sm-12 col-xs-12 callback-container">
            {/* {loading ?
              <div className="callback-box">
                <AiOutlineLoading className="mdi-spin main-color" size="30px" style={{ margin: '16px 0' }} />
                <p style={{ direction: 'rtl' }}>لطفا چند لحظه صبر کنید ...</p>
              </div>
              : */}
            <div className="callback-box">
              <p style={{ fontSize: '18px', fontWeight: 'bold' }}>عملیات پرداخت با خطا مواجه شد</p>

              {/* <a onClick={() => handleTransferToBank()}>
                  ورود مجدد به درگاه پرداخت
                  </a> */}

              <p>
                <Link to="/" >بازگشت به سایت</Link>
              </p>
            </div>
            {/* } */}
          </div>
        </div>
      </div>
    </React.Fragment>
  )

}
export default CallbackFailed;